import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('interazioniLayout');
export const actions = helper.createActions('interazioniLayout', actionTypes);